<template>
  <div class="user-login-5">
    <div class="row bs-reset">
      <div class="col-md-6 bs-reset" style="position: relative;">
        <div class="login-bg">
          <!--<img class="login-logo" src="../assets/global/img/logo.png" />-->
          <img class="bg" src="../assets/pages/img/login/bg1.jpg"/>
          <img class="bg" src="../assets/pages/img/login/bg2.jpg"/>
        </div>

        <div class="login-mark">
          <img src="../assets/pages/img/login/mark.png" width="100%"/>
        </div>

        <div class="login-fg">
          <div class="login-content pull-left">
            <p class="title">新用户注册</p>
            <p><img class="num" src="../assets/pages/img/login/01.png" width="15px"/>扫描下载“视网么AR”APP</p>
            <p><img class="num" src="../assets/pages/img/login/02.png" width="15px"/>用手机号注册</p>
            <p><img class="num" src="../assets/pages/img/login/03.png" width="15px"/>使用手机号/帐号登录视网么CMS</p>
          </div>
          <img class="qr-code pull-right" src="../assets/pages/img/login/qrcode.jpg" width="130px">
        </div>
      </div>
      <div class="col-md-6 login-container bs-reset">
        <div class="login-content" style="margin-top:20%; padding-left: 20%;">
          <img src="../assets/global/img/logo.png" style="margin-bottom: 10%;width:300px;"/>
          <h3 style="font-size:36px;">视网么AR内容管理系统</h3>
          <p> 欢迎使用视网么CMS，发布管理您的AR素材内容！ </p>

          <form role="form" action="javascript:;" class="login-form" method="post" id="loginform"
                style="margin-top: 40px;">
            <div class="form-group">
              <label for="name">帐号</label>
              <input class="form-control form-control-solid placeholder-no-fix form-group input-style" style="width:50%"
                     type="text" autocomplete="off" placeholder="请输入用户名" name="account" required
                     v-model="account"/>
            </div>
            <div class="form-group">
              <label for="inputfile">密码</label>
              <input class="form-control form-control-solid placeholder-no-fix form-group input-style" style="width:50%"
                     type="password" autocomplete="off" placeholder="请输入密码" name="password" required
                     v-model="password"/>
            </div>
            <div style="width:50%;position: relative;">
              <button type="submit" class="btn blue btn-style">登录</button>
            </div>
          </form>
        </div>
        <div class="login-footer" style="padding-left:20%;">
          <div class="row bs-reset">
            <div class="col-xs-7 bs-reset">
              <div class="login-copyright copyright-style">
                <p>Copyrights &copy; 2019 视网么版权所有</p>
                <p><a target="_blank" href="http://www.beian.miit.gov.cn">苏ICP备16011685号-1</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'

  import '../assets/global/plugins/select2/js/select2.full.min.js'
  import '../assets/global/plugins/backstretch/jquery.backstretch.js'
  import { mapActions } from 'vuex'

  export default {
    data () {
      return {
        account: '',
        password: ''
      }
    },
    mounted () {
      this.$localstore.clearAll()

      var ls = []
      $('.login-bg .bg').each(function (idx, it) {
        ls.push($(it).attr('src'))
        $(it).remove()
      })

      $('.login-bg').backstretch(ls, {
        fade: 1000,
        duration: 8000
      })

      $('#loginform').submit(this.submit)
    },
    methods: {
      ...mapActions([
        'showAlert',
        'showLoading',
        'hideLoading',
        'toast',
        'getPermission',
        'initLoginUser',
      ]),
      submit () {
        let self = this

        if (!self.account || !self.password) {
          this.showAlert('用户名和密码不能为空！');
          return
        }
        this.showLoading('登录中，请稍后。。。')

        this.$api.login({
          account: $.trim(self.account),
          password: $.trim(self.password)
        })
          .then(async data => {
            if (data && data.code === 200) {
              await this.getPermission()
              await this.initLoginUser()

              if (this.$isAdmin(data.data.type)) {
                this.$router.push({
                  name: 'projectCheck',
                  params: {
                    type: 'pending'
                  }
                })
              } else {
                this.$router.push({
                  name: 'mgr'
                })
              }
            } else {
              let msg = (data && data.message) || '登录失败！'
              self.showAlert(msg)
            }
          })
          .catch(function () {
            self.showAlert('登录失败，请稍后再试！')
          })
          .finally(function () {
            self.hideLoading()
          })
      }
    }
  }
</script>


<style src="../assets/global/css/components-md.css" scoped></style>
<style src="../assets/global/css/plugins-md.css" scoped></style>
<style src="../assets/pages/css/login-5.min.css" scoped></style>

<style>

  .user-login-5 {
    background: #fff;
  }

  .input-style {
    border-bottom: 2px solid #06adc1 !important;
    padding: 0 !important;
  }

  .btn-style {
    height: 40px !important;
    width: 84px !important;
    border-radius: 4px !important;
    font-size: 16px !important;
    font-weight: 500 !important;
    background-color: #06adc1 !important;
  }

  .copyright-style {
    margin-bottom: 60px;
  }

  .copyright-style a {
    color: #a9b5be;
    text-decoration: none
  }

  .login-fg {
    position: absolute;
    z-index: 2;
    bottom: 0;
    width: 100%;
    margin-bottom: 10%;
  }

  .login-fg .login-content {
    margin-left: 10%;
    color: white;
    font-size: 15px;
  }

  .login-fg p {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .login-mark {
    position: absolute;
    z-index: 1;
    bottom: 0;
    width: 100%;
  }

  .login-fg .login-content .title {
    font-size: 30px;
  }

  .num {
    margin-right: 5px;
  }

  .login-fg .qr-code {
    margin-right: 10%;
    margin-top: 10px;
  }

</style>
